import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { getCurrentInstance, inject, ref, Ref } from 'vue';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useInternationalOffersTracking } from '../tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageDropDown',
  setup(__props) {

const dropDown = ref<{ $el: HTMLElement }>();
const searchPackages = inject<Ref<string[]>>('searchPackages', ref([]));
const searchLanguage = inject<Ref<string[]>>('searchLanguage', ref([]));
const { trackInternationalOffers } = useInternationalOffersTracking({ title: null });
const instance = getCurrentInstance();

async function openDropDown() {
	trackInternationalOffers('languageDropdown');

	const { popoverController } = await import('@/ionic.loader');
	// Create a click event object
	const clickEvent = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window,
	});
	Object.defineProperty(clickEvent, 'target', { value: dropDown.value?.$el, writable: false });
	const popover = await popoverController.create({
		cssClass: 'search-list__pop-over',
		component: () => import('@/features/international-offers/components/LanguageList.vue'),
		componentProps: {
			parent: instance?.proxy,
			propsData: { searchPackages: searchPackages?.value },
		},
		event: clickEvent,
	});
	await popover.present();
	trackInternationalOffers('languageModalOpened');

	popover.onDidDismiss().then(() => {
		trackInternationalOffers('languageModalClosed', { spec: { property: searchLanguage.value.sort().join(', ') } });
	});
}

return { __sfc: true,dropDown, searchPackages, searchLanguage, trackInternationalOffers, instance, openDropDown, BasicButton, faChevronDown }
}

})